import React from 'react';
import { PropTypes } from 'prop-types';
import HrbTranslate from '../language/HrbTranslate';
import './Buttons.scss';


const AltButton = (props) => {
    var buttonClass = "button is-info radius-small alt-button"
    if (props.buttonClass) {
        buttonClass = props.buttonClass + ' ' + buttonClass
    }
    return (
        <div className="alt-button">
            <button type="button" className={buttonClass} onClick={props.onClick} disabled={props.isDisabled}>
                <HrbTranslate text={props.text} params={props.params} />
                {props.children}
            </button>
        </div>
    );
}

AltButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    params: PropTypes.object,
    buttonClass: PropTypes.string
};

export default AltButton;